(() => {
  // Keep server-rendered offer amounts authoritative after every native cart update.
  const syncOffer = () => {
    const drawer = document.getElementById('t4s-mini_cart');
    const form = drawer?.querySelector('#t4s-tab-minicart');
    const items = form?.querySelector('[data-cart-items]');
    const bottom = form?.querySelector('.t4s-drawer__bottom');
    if (!items || !bottom) return;
    let host = form.querySelector(':scope > .cc-cart-fixed-offer');
    if (items.querySelector('.t4s-mini_cart__emty')) {
      host?.remove();
      return;
    }
    const offer = items.querySelector('.cc-3for2--mini');
    if (!offer) return;
    if (!host) {
      host = document.createElement('div');
      host.className = 'cc-cart-fixed-offer';
      bottom.before(host);
    }
    const message = items.querySelector('.cc-3for2__checkout-message');
    host.replaceChildren(offer, ...(message ? [message] : []));
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      syncOffer();
    });
  };
  const observeMiniCartViewport = () => {
    let frame = null;
    let pending = false;
    const sync = () => {
      pending = false;
      const viewport = window.visualViewport;
      const top = viewport ? viewport.offsetTop : 0;
      const height = viewport ? viewport.height : window.innerHeight;
      const width = viewport ? viewport.width : window.innerWidth;
      let bottom = top + height;
      if (frame) {
        const rect = frame.getBoundingClientRect();
        const style = window.getComputedStyle(frame);
        if (style.display !== 'none' && style.visibility !== 'hidden' &&
            rect.height > 0 && rect.width >= width / 2 &&
            rect.top > top && rect.bottom >= bottom - 2) {
          bottom = Math.min(bottom, rect.top);
        }
      }
      document.documentElement.style.setProperty('--cc-cart-viewport-top', top + 'px');
      document.documentElement.style.setProperty('--cc-cart-viewport-height', Math.max(0, bottom - top) + 'px');
    };
    const schedule = () => {
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(sync);
      }
    };
    const frameResize = new ResizeObserver(schedule);
    const frameAttributes = new MutationObserver(schedule);
    const bindFrame = () => {
      const next = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
      if (next !== frame) {
        frameResize.disconnect();
        frameAttributes.disconnect();
        frame = next;
        if (frame) {
          frameResize.observe(frame);
          frameAttributes.observe(frame, { attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
        }
      }
      schedule();
    };
    new MutationObserver((mutations) => {
      const containsPreview = (node) => node.nodeType === 1 &&
        (node.id === 'PBarNextFrame' || node.id === 'PBarNextFrameWrapper' || node.querySelector?.('#PBarNextFrame, #PBarNextFrameWrapper'));
      if (mutations.some((mutation) =>
        [...mutation.addedNodes, ...mutation.removedNodes].some(containsPreview))) {
        bindFrame();
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule, { passive: true });
      window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    }
    bindFrame();
  };

  const start = () => {
    observeMiniCartViewport();
    // The theme replaces both individual items and the whole drawer on AJAX updates.
    new MutationObserver(mutations => {
      if (mutations.some(m => m.target.nodeType === 1 &&
          (m.target.closest('#t4s-mini_cart') || [...m.addedNodes].some(n =>
            n.nodeType === 1 && (n.id === 't4s-mini_cart' || n.querySelector?.('#t4s-mini_cart')))))) schedule();
    }).observe(document.body, {childList: true, subtree: true});
    syncOffer();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
